/** One guide on the hub or under "Keep reading": the hub's card, unchanged. */
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ArrowRight, Wallet } from 'lucide-react';

export default function GuideCard({ to, category, title, description, icon: Icon = Wallet }) {
  return (
    <Link
      to={to}
      className="group block rounded-[1.25rem] bg-[#1d1d1f] p-6 md:p-7 hover:bg-[#252528] transition-colors h-full"
    >
      <div className="flex items-start gap-4 mb-5">
        <Icon className="w-6 h-6 text-white/70 flex-shrink-0 mt-0.5" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
        <div className="flex-1 min-w-0">
          <span className="text-[12px] text-white/45 font-normal uppercase tracking-wider mb-2 block">{category}</span>
          <h3 className="text-white font-semibold text-[17px] leading-snug group-hover:text-white/95 transition-colors">{title}</h3>
        </div>
      </div>
      <p className="text-white/65 text-[15px] leading-relaxed mb-5">{description}</p>
      <div className="flex items-center gap-2 text-white/70 text-[14px] font-medium group-hover:text-white/90 transition-colors">
        Read Guide
        <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" strokeWidth={2} />
      </div>
    </Link>
  );
}

GuideCard.propTypes = {
  to: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
};
